import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { CodeLikeProComponent } from './app.component';
import { WelcomeComponent } from './welcome/welcome.component';
export class CodeLikeProModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [
    CodeLikeProComponent,
    WelcomeComponent
  ],
  imports: [
    BrowserModule
  ],
  providers: [],
  bootstrap: [CodeLikeProComponent],
  exports: [CodeLikeProComponent, WelcomeComponent]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function CodeLikeProModule_tsickle_Closure_declarations() {
/** @type {?} */
CodeLikeProModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CodeLikeProModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
